import React from 'react'
import PropTypes from 'prop-types'

import { ArrowLinkList } from './ArrowLinkList/ArrowLinkList'
import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'
import { SectionBlock } from '../SectionBlock/SectionBlock'

const ArrowLinkListSection = ({ title, list = [], onClick, moreTitle, lessTitle, dark }) => {
    return (
        <SectionBlock withContainer dark={dark}>
            <TopSectionTitle title={title} underlined dark={!dark} centered />
            <ArrowLinkList
                links={list}
                moreTitle={moreTitle}
                lessTitle={lessTitle}
                onClick={onClick}
                dark={dark}
            />
        </SectionBlock>
    )
}

ArrowLinkListSection.propTypes = {
    title: PropTypes.string,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            name: PropTypes.string
        })
    ),
    onClick: PropTypes.func,
    moreTitle: PropTypes.string,
    lessTitle: PropTypes.string,
    dark: PropTypes.bool
}

ArrowLinkListSection.defaultProps = {
    dark: false
}

export { ArrowLinkListSection }
